export function sendDesktopNotification(title, options, onClickFunction) {
  const notification = new Notification(title, options);
  notification.onclick = onClickFunction;
}

export function checkDesktopNotificationPermissions() {
  if (!('Notification' in window)) return false;
  if (Notification.permission === 'granted') { return true; }
  else if (Notification.permission !== 'denied') {
    Notification.requestPermission(permission => { return (permission === 'granted') ? true : false; });
  }
}

export function checkNotificationStatusCanBeSet() {
  if (!('Notification' in window)) return false;
  if (Notification.permission === 'granted') { return false; }
  else if (Notification.permission !== 'denied') {
    return true;
  }
}

export function requestDesktopNotificationPermissions(callback) {
  Notification.requestPermission(permission => { callback(); });
}



/** WEBPACK FOOTER **
 ** ./src/utils/notifications-service.js
 **/